/**
 * BotForge — Force Add-to-Cart enabled on digital-service products.
 *
 * Dawn's product-form.js toggles the submit button's [disabled] attribute
 * when the user switches variants, based on Shopify's computed availability.
 * For BotForge Info Agent / Action Agent (no inventory tracking) this fires
 * incorrectly. Watchdog below undoes the disable on digital-service pages.
 *
 * Activation rule: page body has class template-product AND product_type == Digital Service.
 * We detect via a data attribute set by main-product.liquid, OR by URL product handle prefix.
 */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  // Digital handle detection — BotForge product handles contain "botforge"
  var handle = (document.body.className.match(/template-suffix-([a-z0-9-]+)/) || [])[1] || '';
  var isBotForge = /botforge|info-agent|info-bot|action-agent|action-bot/i.test(window.location.pathname) ||
                   /botforge/i.test(handle);
  if (!isBotForge) return;

  function enableForm() {
    document.querySelectorAll('product-form').forEach(function (pf) {
      var btn = pf.querySelector('button[type="submit"]');
      var hid = pf.querySelector('input[name="id"]');
      if (btn && btn.hasAttribute('disabled')) {
        btn.removeAttribute('disabled');
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Add to cart';
      }
      if (hid && hid.hasAttribute('disabled')) hid.removeAttribute('disabled');
    });
  }

  // Run on load
  enableForm();

  // Watch for Dawn's JS mutating disabled attr on submit button
  var observer = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'disabled') {
        enableForm();
      }
    });
  });
  document.querySelectorAll('product-form button[type="submit"], product-form input[name="id"]').forEach(function (el) {
    observer.observe(el, { attributes: true, attributeFilter: ['disabled'] });
  });

  // Also on variant change event (Dawn emits 'variant:change' on product-info)
  document.addEventListener('variant:change', enableForm);
  document.addEventListener('click', function (e) {
    if (e.target.matches('input[name="Tier"], label[for^="Tier"], .product-form__input input, .product-form__input label')) {
      setTimeout(enableForm, 50);
      setTimeout(enableForm, 200);
    }
  });
})();
